export default {
  businessType: '业务类型',
  grDate: '日期',
  reworkDate: '复检日期',
  cartonPe: '箱 PE',
  summary: '总览',
  vendor: '供应商',
  plant: '仓库',
  byCarton: '箱数',
  byUnit: '件数',
  giedASNQty: 'GIed/ASN 数量 (箱)',
  giedASNQtyByUnit: 'GIed/ASN 数量 (件)',
  reworkQty: '复检箱数',
  rework: '复检%',
  specialProductQty: '特殊产品箱数',
  productShortageQty: '实物少件箱数',
  productOverageQty: '实物多件箱数',
  physicalSkuIncorrectQty: '实物错误箱数',
  manualUnitScanQty: '人工逐件处理箱数',
  submitSysUpdateQty: '无处理提交箱数',
  relabelQty: '补标箱数',
  relabel: '补标 %',
  noRfidTagQty: 'RFID缺失箱数',
  scanNoResponseQty: 'RFID读取无反应箱数',
  multipleRfidCartonQty: '多标箱数',
  physicalSkuCorrectQty: '错标箱数',
  reworkQtyByUnit: '复检件数',
  specialProductQtyByUnit: '特殊产品件数',
  physicalSkuIncorrectQtyByUnit: '实物错误件数',
  relabelQtyByUnit: '补标件数',
  noRfidTagQtyByUnit: 'RFID缺失件数',
  scanNoResponseQtyByUnit: 'RFID读取无反应件数',
  multipleRfidCartonQtyByUnit: '多标件数',
  physicalSkuCorrectQtyByUnit: '错标件数'
}
